import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  GET_ALL_NOTIFICATIONS,
  GET_TASK_NOTIFICATION,
  MARK_ALL_NOTIFICATION_AS_READ,
  MARK_SINGLE_NOTIFICATION_AS_READ,
} from "../../utils/constants";
import customBaseQuery from "../../utils/CustomBaseQuery/customBaseQuery";
import { getUserToken } from "../../utils/utilityFunctions/localServices";

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchNotificationData: builder.query({
      query: ({ user_id, company_id }) => ({
        url: GET_ALL_NOTIFICATIONS,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify({ user_id, company_id }), // Ensure body is stringified
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    markAllNotificationAsRead: builder.mutation({
      query: () => ({
        url: MARK_ALL_NOTIFICATION_AS_READ,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}), // Ensure body is stringified
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    markSingleNotificationAsRead: builder.mutation({
      query: ({ payload }) => ({
        url: MARK_SINGLE_NOTIFICATION_AS_READ,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // Ensure body is stringified
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const {
  useFetchNotificationDataQuery,
  useMarkAllNotificationAsReadMutation,
  useMarkSingleNotificationAsReadMutation,
} = notificationApi;
